import { useCalendarContext } from "Bands/contexts";
import { FC } from "react";

import { CalendarPicker as Component } from "shared/components";

interface CalendarPickerProps {}

export const CalendarPicker: FC<CalendarPickerProps> = () => {
  const { date, setDate } = useCalendarContext();

  return <Component date={date} setDate={setDate} />;
};
